import React from 'react';
import blog from '../../assests/img/blog.jpg';
import { Card } from 'react-bootstrap';

const Blog = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Blog</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Blog
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-12 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <div className="blog_card_sec">
                                                    <div className="blog_card">
                                                        <Card>
                                                            <Card.Body>
                                                                <div className='card_bg'>
                                                                    <img src={blog} alt='blog' width="100%" style={{ borderRadius: "10px 10px 0 0" }} />
                                                                    <div className='card_sec'>
                                                                        <p>
                                                                            15 October, 2024
                                                                        </p>
                                                                        <h4>Blog Post Title</h4>
                                                                        <a href="blog-post-title" data-bs-toggle="modal"
                                                                            data-bs-target="#read" style={{}}>
                                                                            <span>→</span> Read More
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default Blog;